export const contentData = {
    spanish: {
        button: 'Continuar',
        back: 'Regresar',
        responsible_banner: {
            responsible: 'responsible',
            responsible_id: 'responsible_id',
            completed_date: 'completed_date'
        },
        declarations: [
            {
                id: 'diot_folio',
                label: 'DIOT Folio',
            },
            {
                id: 'diot_presentation_limit_date',
                label: 'DIOT Fecha Límite de Presentación',
            },
        ],
        declarations_date: {
            id: 'payment_limit_date',
            label: 'Fecha límite de Pago'
        }
    }
}
